export default "__VITE_ASSET__BWXs1ENg__"